<template>
  <div class="faq-container">
    <h1 class="faq-title">Frequently Asked Questions</h1>
    <ul class="faq-list">
      <li class="faq-item">
        <div class="faq-q">What is HypnoMaker and how does it work?</div>
        <div class="faq-a">
          HypnoMaker is a simple yet powerful desktop app for creating fully customized hypnosis, affirmation, bimbo, and sissy slideshow videos, with no video editing needed. All you have to do is choose your script, point it at a folder filled with images and videos, and click <b>Create Video</b>. You’ll have a custom slideshow in minutes.
        </div>
      </li>
      <li class="faq-item">
        <div class="faq-q">How much can I customize my videos?</div>
        <div class="faq-a">
          As much or as little as you want. HypnoMaker lets you:
          <ul class="faq-bullets">
            <li>Write your own scripts with the built-in editor (works with built-in TTS for full voiceovers)</li>
            <li>Handpick individual files and set their exact order, or just point at a folder</li>
            <li>Add custom audio: music, TTS, binaural beats, or the source audio from your own clips</li>
            <li>Output single-panel or layered three-panel video</li>
            <li>Choose from animated GIF overlays, video filters, and per-video transitions</li>
            <li>Adjust timing, caption fonts and colors, and effects to fit your vision</li>
          </ul>
          You can go deep on customization, or just load up a folder and click "go."
        </div>
      </li>
      <li class="faq-item">
        <div class="faq-q">Can I use binaural beats or my own audio?</div>
        <div class="faq-a">
          Absolutely! You can include your own music, TTS tracks, or binaural audio. Just select your audio file in the app and your slideshow will sync to it. You can also pull the audio straight off your video clips and mix it into the output.
        </div>
      </li>
      <li class="faq-item">
        <div class="faq-q">What voices are available?</div>
        <div class="faq-a">
          All 102 built-in scripts ship with prerendered voiceovers in both realistic female voices (ElevenLabs) and male voices (Fish Audio). For custom scripts, premium users can bring their own ElevenLabs or Fish Audio API key and use any voice in their libraries; Fish Audio is the noticeably cheaper option if you generate a lot.
        </div>
      </li>
      <li class="faq-item">
        <div class="faq-q">Can I use HypnoMaker for any kind of content?</div>
        <div class="faq-a">
          Yes! HypnoMaker is a general-purpose video creation tool. Use it for whatever you want: hypnosis, affirmations, meditation, erotic content, personal projects, or anything else. The built-in scripts lean adult, but the tool itself has no restrictions on what you make with it.
        </div>
      </li>
      <li class="faq-item">
        <div class="faq-q">Is HypnoMaker free?</div>
        <div class="faq-a">
          The core app is free to download and use. A premium tier is available on <a href="https://hypnomaker.itch.io/hypnomaker" target="_blank" rel="noopener" style="color:#ba338c;font-weight:600;">itch.io</a> that unlocks PMV Mode, the full script library, the custom script editor, and all future premium features.
        </div>
      </li>
      <li class="faq-item">
        <div class="faq-q">What platforms does it run on?</div>
        <div class="faq-a">
          HypnoMaker currently runs on Windows. A standalone Linux build is actively in progress, and a web version is in development so people on Android, iPhone, Mac, and Linux can use HypnoMaker without being tied to a Windows box.
        </div>
      </li>
      <li class="faq-item">
        <div class="faq-q">How do I get help or report a bug?</div>
        <div class="faq-a">
          Reach out anytime via the <a href="mailto:remedy@hypnomaker.com" style="color:#ba338c;font-weight:600;">Contact</a> link below, or on the app's itch.io page.
        </div>
      </li>
      <li class="faq-item">
        <div class="faq-q">Are there more features coming?</div>
        <div class="faq-a">
          Yes! Recent releases added three-panel mode, working beat-sync, male voices, bring-your-own ElevenLabs and Fish Audio keys, source audio mixing, a per-file picker, and 60+ new scripts, bringing the library to 102. Next up: a web version and a standalone Linux build. More is in the works, and your feedback genuinely shapes what comes next.
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
// static page
</script>

<style scoped>
.faq-container {
  max-width: 700px;
  margin: 120px auto 24px auto;
  background: #fff7fb;
  border-radius: 18px;
  box-shadow: 0 4px 24px #e47ebc30;
  padding: 2.3rem 2rem 2rem 2rem;
}
.faq-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.7rem;
  color: #ba338c;
  text-align: center;
  letter-spacing: 1px;
}
.faq-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.faq-item {
  margin-bottom: 0.5rem;
}
.faq-q {
  font-size: 1.1rem;
  font-weight: 600;
  color: #b12a77;
  margin-bottom: 0.5rem;
}
.faq-a {
  font-size: 1rem;
  color: #342046;
  margin-left: 0.1rem;
  line-height: 1.5;
}
.faq-bullets {
  list-style: none;
  padding: 0;
  margin: 0.6em 0 0.6em 0;
}
.faq-bullets li {
  position: relative;
  padding: 0.3em 0 0.3em 1.4em;
  color: #342046;
  border-bottom: 1px solid #f5d6eb;
}
.faq-bullets li:last-child {
  border-bottom: none;
}
.faq-bullets li::before {
  content: '✦';
  position: absolute;
  left: 0;
  color: #e47ebc;
  font-size: 10px;
  top: 0.45em;
}
</style>